// src/components/EditProfileModal.jsx (ACTUALIZADO)
import React, { useState, useEffect } from 'react';
import '../assets/styles/modal.css';
import '../assets/styles/EditProfileModal.css';
import { db } from '../firebaseConfig';
import { doc, getDoc } from "firebase/firestore";

const RequiredAsterisk = () => (
  <span className="required-asterisk" title="Campo obligatorio"> *</span>
);

const EditProfileModal = ({ currentUserData, onClose, onSave, isLoading }) => {

  const [nombre, setNombre] = useState(currentUserData.fullName || '');
  const [username, setUsername] = useState(currentUserData.username || '');
  const [telefono, setTelefono] = useState('');
  const [pais, setPais] = useState('');
  const [tipoDocumento, setTipoDocumento] = useState('');
  const [rut, setRut] = useState('');
  // --- 1. AÑADIR ESTADO PARA PASAPORTE ---
  const [numeroPasaporte, setNumeroPasaporte] = useState('');
  // ------------------------------------
  const [direccion, setDireccion] = useState('');
  const [qrFile, setQrFile] = useState(null);
  const [existingQrUrl, setExistingQrUrl] = useState(null);

  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchExtraData = async () => {
      try {
        // Asegúrate de que esto coincida con tu regla de Firestore ('usuarios')
        const userDocRef = doc(db, "usuarios", currentUserData.uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const data = userDoc.data();
          setTelefono(data.telefono || '');
          setPais(data.pais || '');
          setTipoDocumento(data.tipoDocumento || '');
          setRut(data.rut || '');
          // --- 2. CARGAR EL DATO DEL PASAPORTE ---
          setNumeroPasaporte(data.numeroPasaporte || '');
          // --------------------------------------
          setDireccion(data.direccion || '');
          setExistingQrUrl(data.qrCodeUrl || null);
        }
      } catch (err) {
        console.error("Error cargando datos de perfil:", err);
        setError("No se pudieron cargar los datos del perfil.");
      }
    };
    fetchExtraData();
  }, [currentUserData.uid]);

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setQrFile(e.target.files[0]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const profileData = {
      nombre,
      username,
      telefono,
      pais,
      tipoDocumento,
      rut,
      // --- 3. ENVIAR EL DATO DEL PASAPORTE AL GUARDAR ---
      numeroPasaporte,
      // ---------------------------------------------
      direccion,
    };

    onSave(profileData, qrFile);
  };

  return (
    // Modal grande, usamos z-index alto
    <div className="modal-overlay" style={{ zIndex: 1100 }} onClick={onClose}>
      <div
        className="modal-content"
        style={{ maxWidth: '800px' }} // <-- MODAL MÁS GRANDE (800px)
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-close" onClick={onClose}>&times;</button>

        <form onSubmit={handleSubmit}>
          <h2>Editar Perfil y Contratación</h2>
          <p>
            Completa todos los campos obligatorios (*) para activar
            el servicio de Trading Automatizado.
          </p>

          {error && <div className="alert alert-danger">{error}</div>}

          {/* APLICAR NUEVA CLASE PARA ESTILOS Y SCROLL */}
          <div className="profile-modal-body">

            {/* Fila de Nombre y Username */}
            <div className="profile-form-row">
              <div className="input-group">
                <label>Nombre Completo<RequiredAsterisk /></label>
                <input id="edit-profile-nombre" name="fullName" type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} autoComplete="name" required />
              </div>
              <div className="input-group">
                <label>Nombre de Usuario<RequiredAsterisk /></label>
                <input id="edit-profile-username" name="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" required />
              </div>
            </div>

            {/* Fila de Teléfono y País */}
            <div className="profile-form-row">
              <div className="input-group">
                <label>Teléfono<RequiredAsterisk /></label>
                <input id="edit-profile-telefono" name="tel" type="tel" value={telefono} onChange={(e) => setTelefono(e.target.value)} autoComplete="tel" required />
              </div>
              <div className="input-group">
                <label>País<RequiredAsterisk /></label>
                <input id="edit-profile-pais" name="country" type="text" value={pais} onChange={(e) => setPais(e.target.value)} autoComplete="country-name" required />
              </div>
            </div>

            {/* --- 4. FILA DE DOCUMENTO ACTUALIZADA --- */}
            <div className="profile-form-row">
              <div className="input-group">
                <label>Tipo de Documento<RequiredAsterisk /></label>
                <select value={tipoDocumento} onChange={(e) => setTipoDocumento(e.target.value)} required>
                  <option value="">Seleccionar...</option>
                  <option value="cedula">Cédula de Identidad</option>
                  <option value="pasaporte">Pasaporte</option>
                </select>
              </div>

              {/* Campo condicional para RUT o Pasaporte */}
              <div className="input-group">
                {tipoDocumento === 'cedula' ? (
                  <>
                    <label>RUT<RequiredAsterisk /></label>
                    <input id="edit-profile-rut" name="rut" type="text" value={rut} onChange={(e) => setRut(e.target.value)} required />
                  </>
                ) : tipoDocumento === 'pasaporte' ? (
                  <>
                    <label>N° Pasaporte<RequiredAsterisk /></label>
                    <input
                      id="edit-profile-pasaporte"
                      name="passport"
                      type="text"
                      value={numeroPasaporte}
                      onChange={(e) => setNumeroPasaporte(e.target.value)}
                      required
                    />
                  </>
                ) : (
                  <>
                    {/* Placeholder para mantener el layout */}
                    <label>N° Documento</label>
                    <input type="text" value="Selecciona un tipo" disabled />
                  </>
                )}
              </div>
            </div>
            {/* --- FIN DE LA ACTUALIZACIÓN --- */}

            {/* Campo de Dirección */}
            <div className="input-group">
              <label>Dirección (Opcional)</label>
              <input id="edit-profile-direccion" name="address" type="text" value={direccion} onChange={(e) => setDireccion(e.target.value)} autoComplete="street-address" />
            </div>

            {/* Campo de QR */}
            <div className="input-group">
              <label>Código QR de Binance API<RequiredAsterisk /></label>
              <p className="qr-note">
                Sube la imagen del código QR que generaste desde tu cuenta de Binance.
              </p>
              <input
                id="edit-profile-qr"
                name="qr-file"
                type="file"
                onChange={handleFileChange}
                accept="image/*"
                required={!existingQrUrl}
              />
              {existingQrUrl && !qrFile && (
                <p className="qr-success-note">
                  Ya has subido un código QR. Sube uno nuevo solo si quieres reemplazarlo.
                </p>
              )}
            </div>
          </div>

          <div className="modal-actions">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isLoading}
            >
              {isLoading ? 'Guardando...' : 'Guardar Cambios y Activar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProfileModal;